export const NBSP = String.fromCharCode(0x00a0)
export const UP_TRIANGLE = String.fromCharCode(0x25b2)
export const DOWN_TRIANGLE = String.fromCharCode(0x25bc)
export const CURRENCY = '$'
export const KEYCODE_UP = 38
export const KEYCODE_DOWN = 40
export const KEYCODE_PGUP = 33
export const KEYCODE_PGDOWN = 34
export const KEYCODE_HOME = 36
export const KEYCODE_END = 35
export const KEYCODE_ENTER = 13
export const KEYCODE_ESC = 27
export const KEYCODE_TAB = 9
export const KEYCODE_SPACE = 32
export const KEYCODE_BACKSPACE = 8
export const KEYCODE_DELETE = 46
export const KEYCODE_Z = 90
export const KEYCODE_Y = 89

export const IS_MAC = 'undefined' !== typeof window && window.navigator.userAgent.toLowerCase().includes('mac')
export const IS_SAFARI =
  'undefined' !== typeof window && /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent)
export const IS_IE11 =
  'undefined' !== typeof window &&
  'undefined' !== typeof document &&
  Boolean(window.MSInputMethodContext) &&
  Boolean(document.documentMode)
